module.exports = __webpack_public_path__ + "img/dg-browse-vehicles-default-honda.0ae39792.png";